import { Injectable } from "@angular/core";
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants"
import { Router } from "@angular/router";

@Injectable()
export class HttpClient extends Http {

	constructor(backend: XHRBackend, options: RequestOptions, private constants: Constants, private router: Router) {
		super(backend, options);

		if(constants.user && constants.user.jwt)
			options.headers.set("Authorization", `Bearer ${constants.user.jwt.token}`);
	}

	request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
		if(typeof url === "string") {
			if(!options)
				options = { headers: new Headers() };

			if(this.constants.user && this.constants.user.jwt)
				options.headers.set("Authorization", `Bearer ${this.constants.user.jwt.token}`);
		} else {
			if(this.constants.user && this.constants.user.jwt)
				url.headers.set("Authorization", `Bearer ${this.constants.user.jwt.token}`);
		}

		var request = super.request(url, options).catch((error: any): Observable<any> => {
			if(error.status === 401)
				this.router.navigate(["/"]);

			return Observable.throw(error.message || error);
		});

		return request;
	}
}